import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8f411d1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "min-height": "100%"
  }
};
const _hoisted_2 = {
  class: "courseOutline clearfix"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "center_img"
}, null, -1));

const _hoisted_4 = {
  class: "virtual_contain"
};
const _hoisted_5 = {
  class: "virtual_head"
};
const _hoisted_6 = {
  class: "virtual_head_right"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "year"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circle_icon"
}, null, -1));

const _hoisted_10 = {
  key: 0,
  class: "line"
};
const _hoisted_11 = {
  class: "virtual_content"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "time_line"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode("包含");

const _hoisted_16 = {
  class: "num"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("份课程大纲");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_Right = _resolveComponent("Right");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_Link = _resolveComponent("Link");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    menuInfo: _ctx.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => _ctx.menuInfo = $event),
    onSpocName: _ctx.SpocName,
    onGetUserInfo: _ctx.getUserInfo
  }, null, 8, ["menuInfo", "onSpocName", "onGetUserInfo"]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.yearList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: _normalizeClass(['year_li', item.grade == $data.checkYear ? 'check_year' : '']),
      onClick: $event => $options.changeYear(item.grade)
    }, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.grade || '0') + "版", 1), _hoisted_9], 10, _hoisted_7);
  }), 128)), $data.yearList.length ? (_openBlock(), _createElementBlock("div", _hoisted_10)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courseList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "virtual_li",
      key: item.id
    }, [_createElementVNode("a", {
      href: `/courseOutlineDetail.html?organId=${item.organId}&menuId=${$data.menuId}&grade=${$data.checkYear}`
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(item.organName), 1), _createElementVNode("span", null, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Right)]),
      _: 1
    })])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, [_hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString(item.total), 1), _hoisted_17]), _createElementVNode("span", null, _toDisplayString(item.updateTime) + "更新", 1)])], 8, _hoisted_12)]);
  }), 128))])]), $data.footerItem && $data.footerItem.home_open ? (_openBlock(), _createBlock(_component_Link, {
    key: 0,
    menu: $data.footerItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), _createVNode(_component_Footer)])]);
}